// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3XdIt","modalFooterButton":"ModalNotes_modalFooterButton___PL7Y"};